<template>
    <div class="mb-4 list-credentials__heading list-credentials__heading--dark clearfix" v-if="project">
        <svg-project/>
        <div class="pull-left">
            <h1 class="h2">
                    {{ project.name }}
            </h1>
            <p class="mb-0">{{ project.description }}</p>
            <small v-for="(provProject, index) in project.provs" class="mb-0 mr-1">Project ID on {{ provProject.region_name }}: {{ provProject.os_id }}</small>
        </div>
    </div>
</template>

<script>
const svgProject = () => import('@/components/svg/svg-project');

export default {
    data() {
        return {
            currentProject: JSON.parse(localStorage.getItem('current_project')).name,
        }
    },

    computed: {
        project() {
            if (this.$store.state.team.current.projects) {
                return this.$store.state.team.current.projects.find(item => item.name === this.currentProject);
            } else {
                return false;
            }
        },
    },

    components: {
        svgProject,
    },
}
</script>
